import { render, staticRenderFns } from "./CreateVoltage.vue?vue&type=template&id=e622d410&scoped=true"
import script from "./CreateVoltage.vue?vue&type=script&lang=js"
export * from "./CreateVoltage.vue?vue&type=script&lang=js"
import style0 from "./CreateVoltage.vue?vue&type=style&index=0&id=e622d410&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e622d410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/votech/Documents/project/web/wave-writer-joecig/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e622d410')) {
      api.createRecord('e622d410', component.options)
    } else {
      api.reload('e622d410', component.options)
    }
    module.hot.accept("./CreateVoltage.vue?vue&type=template&id=e622d410&scoped=true", function () {
      api.rerender('e622d410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CreateVoltage.vue"
export default component.exports